/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Export_FileInputs */

const en_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the export menu`)
};

const fr_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le menu d'export`)
};

const de_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffnen Sie das Exportmenü`)
};

const it_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apri il menu di esportazione`)
};

const ru_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откройте меню экспорта`)
};

const es_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir el menú de exportación`)
};

const zh_cn2_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开导出菜单`)
};

const ja_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポートメニューを開く`)
};

const hi_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात मेनू खोलें`)
};

const pt_pt2_shortcut_keys_desc_export_file = /** @type {(inputs: Shortcut_Keys_Desc_Export_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra o menu de exportação`)
};

/**
* | output |
* | --- |
* | "Open the export menu" |
*
* @param {Shortcut_Keys_Desc_Export_FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_export_file = /** @type {((inputs?: Shortcut_Keys_Desc_Export_FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Export_FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_export_file(inputs)
	if (locale === "de") return de_shortcut_keys_desc_export_file(inputs)
	if (locale === "it") return it_shortcut_keys_desc_export_file(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_export_file(inputs)
	if (locale === "es") return es_shortcut_keys_desc_export_file(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_export_file(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_export_file(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_export_file(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_export_file(inputs)
	return en_shortcut_keys_desc_export_file(inputs)
});